import React, { Component } from 'react';
import JobsOperationsApiHandler from './../../JobsOperationsApiHandler.js';
import DateWiseJobs from './DateWiseJobs.js';
import JpinJobsDashboard from './JpinJobsDashboard.js';
import Loader from './../../../../commons/Loader.js';
import ErrorBox from './../../../../commons/ErrorBox';


export default class JobsDashboard extends Component {
	constructor(props) {
		super(props);
		this.state = {
			jobs: null,
			dateDataToShow: null,
			created: 0,
			inProgress: 0,
			currentJobDetails: null,
			showLoader: false,
			error: null
		};
		this.jobDetails = this.jobDetails.bind(this);
		this.backFromJobDetails = this.backFromJobDetails.bind(this);
		this.closeError = this.closeError.bind(this);
	}

	closeError() {
    	this.setState({error: null});
  	}

	seggregateForEachDate() {
		var jobs = this.state.jobs;
	  	var result = {};
	  	var created = 0;
	  	var inProgress = 0;
	  	//Making map for date to jobs array {date:[jobs]}
	  	for(var i of jobs) {
	  		if(!result[i.assignedDate]) {
	  			result[i.assignedDate] = [];
	  		}
	  		result[i.assignedDate].push(i);
	  		if(i.status === 'CREATED') {
	  			created++;
	  		} else {
	  			inProgress++;
	  		}
	  	}
	  	var arrayForDateMap = Object.keys(result).map((key)=>{return {date:key, jobs:result[key]} });
	  	arrayForDateMap.sort(function(a, b){
    		return b.date-a.date
		});
	  	this.setState({
	  		// arrayForDateMap: arrayForDateMap,
	  		created: created,
	  		inProgress: inProgress,
	  		dateDataToShow: arrayForDateMap
	  	});
	}

	jobDetails(jobDetailsToSet) {
		if(jobDetailsToSet)
			this.setState({
				currentJobDetails: jobDetailsToSet
			});
	}

	fetchJobsToShow() {
		this.setState({showLoader:true});
		JobsOperationsApiHandler.getJobsForDashboardShow(this.props.operationType)
			.then(function(resp) {
				this.setState({jobs: resp});
	  			this.seggregateForEachDate();
			}.bind(this)).catch(function(error) {
				this.setState({error: error.error.error});
			}.bind(this)).finally(function() {
				this.setState({showLoader:false});
			}.bind(this))
	}

	backFromJobDetails() {
		this.setState({
			currentJobDetails: null
		});
	}


	componentWillMount() {
		this.fetchJobsToShow()
	}

	showDateWiseJobs(dates) {
		var datesWiseData = dates.map((date, index) => {
			return(
				<div key={index}>
					<DateWiseJobs date={date} operationType={this.props.operationType} jobDetails={this.jobDetails}/>
				</div>
			);
		});
		return datesWiseData;
	}

	render() {
		return(
			<div>{(this.state.dateDataToShow)?
				<div>
				{(!this.state.currentJobDetails)?
					<div>
						<div className="putaway-header">
							<div className="row">
								<div className="col-xs-4 col-sm-3 col-md-2 no-right-padding-xs">
									<div className="job-done-label">Pending {this.props.operationName}</div>
									<div className="job-done-value">{this.state.jobs.length}</div>
								</div>
								<div className="col-xs-4 col-sm-3 col-md-2">
									<div className="job-done-label">Not Started</div>
									<div className="job-done-value">{this.state.created}</div>
								</div>
								<div className="col-xs-4 col-sm-3 col-md-2">
									<div className="job-done-label">In Progress</div>
									<div className="job-done-value">{this.state.inProgress}</div>
								</div>
								<div className="col-md-6">
								</div>
							</div>
						</div>
						<div>
							<div className="putaway-wrapper">
								{this.showDateWiseJobs(this.state.dateDataToShow)}
							</div>
						</div>
					</div>
					:
					<div>
						<div className="putaway-header">
							<button className="btn btn-default back-button" onClick={this.backFromJobDetails}><i className="fas fa-chevron-left"></i> &nbsp;&nbsp;Back</button>
						</div>
						<JpinJobsDashboard jobDetails={this.state.currentJobDetails}/>
					</div>
				}
				</div>:null
			}
			{(this.state.showLoader)?
				<Loader />:null
			}
			{(this.state.error)?
		 		<ErrorBox errorText={this.state.error} closeError={this.closeError}/>:null
    		}
			</div>

		)
	}
}


// WEBPACK FOOTER //
// ./src/screens/JobOperations/Components/Commons/JobsDashboard.js